import { render, staticRenderFns } from "./liveevent.vue?vue&type=template&id=e7adb6c2&"
import script from "./liveevent.vue?vue&type=script&lang=js&"
export * from "./liveevent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports